import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LinkedInIcon, FacebookIcon, InstagramIcon } from '../components/Icons';
import { services } from '../data/services';

const Footer = () => {
    const location = useLocation();

    const handleNavClick = (sectionId) => {
        if (location.pathname === '/') {
            const element = document.getElementById(sectionId);
            if (element) {
                const navHeight = 80;
                const targetPosition = element.offsetTop - navHeight;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
        }
    };

    // Split services into two columns for better layout
    const midpoint = Math.ceil(services.length / 2);
    const servicesColumn1 = services.slice(0, midpoint);
    const servicesColumn2 = services.slice(midpoint);

    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    {/* Logo and Description */}
                    <div className="col-lg-3 mb-4 mb-lg-0">
                        <img
                            src="/images/vgw-logo-white.png"
                            alt="Vintage Glass Works"
                            className="footer-logo"
                        />
                        <p className="footer-text">
                            Dedicated to the preservation of architectural heritage through expert craftsmanship.
                        </p>
                    </div>

                    {/* Services Column 1 - Direct links to service pages */}
                    <div className="col-6 col-md-4 col-lg-2 offset-lg-1 mb-4 mb-md-0">
                        <h4 className="footer-heading">Services</h4>
                        <ul className="footer-links">
                            {servicesColumn1.map((service, index) => (
                                <li key={index}>
                                    <Link to={`/services/${service.id}`}>
                                        {service.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services Column 2 - Direct links to service pages */}
                    <div className="col-6 col-md-4 col-lg-2 mb-4 mb-md-0">
                        <h4 className="footer-heading">&nbsp;</h4>
                        <ul className="footer-links">
                            {servicesColumn2.map((service, index) => (
                                <li key={index}>
                                    <Link to={`/services/${service.id}`}>
                                        {service.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company Links */}
                    <div className="col-6 col-md-4 col-lg-2 mb-4 mb-md-0">
                        <h4 className="footer-heading">Company</h4>
                        <ul className="footer-links">
                            <li>
                                <Link to="/#about" onClick={() => handleNavClick('about')}>
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link to="/#portfolio" onClick={() => handleNavClick('portfolio')}>
                                    Portfolio
                                </Link>
                            </li>
                            <li>
                                <Link to="/#process" onClick={() => handleNavClick('process')}>
                                    Our Process
                                </Link>
                            </li>
                            <li>
                                <Link to="/#contact" onClick={() => handleNavClick('contact')}>
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className="col-6 col-md-4 col-lg-2">
                        <h4 className="footer-heading">Contact</h4>
                        <ul className="footer-links footer-contact">
                            <li>
                                <a href="tel:+12075887000">
                                    (207) 588-7000
                                </a>
                            </li>
                            <li>
                                <a href="mailto:info@vintageglassworks.com">
                                    info@vintageglassworks.com
                                </a>
                            </li>
                            <li>
                                <span>521 Water St<br />Gardiner, ME 04345</span>
                            </li>
                        </ul>
                        <div className="footer-social">
                            <a
                                href="https://www.linkedin.com/company/vintage-glass-works"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="LinkedIn"
                            >
                                <LinkedInIcon />
                            </a>
                            <a
                                href="https://www.facebook.com/vintageglassworksrestoration"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Facebook"
                            >
                                <FacebookIcon />
                            </a>
                            <a
                                href="https://www.instagram.com/vintageglassworks"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-social-link"
                                aria-label="Instagram"
                            >
                                <InstagramIcon />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p className="footer-copyright">
                            © {new Date().getFullYear()} Vintage Glass Works. All rights reserved.
                        </p>
                        <div className="footer-legal-links">
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <Link to="/terms-of-service">Terms of Service</Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
